/**
 * Cities — top cities by contact count. Replaces merchant-rank.
 */
import { store } from '../store.ts';

export class DialCities extends HTMLElement {
  #shadow = this.attachShadow({ mode: 'open' });
  #unsub?: () => void;

  connectedCallback(): void {
    this.#unsub = store.subscribe((s) => {
      if (s.summary) this.#render(s.summary.by_city);
    });
  }
  disconnectedCallback(): void { this.#unsub?.(); }

  #render(by_city: Record<string, number>): void {
    const entries = Object.entries(by_city).sort((a, b) => b[1] - a[1]).slice(0, 8);
    if (!entries.length) {
      this.#shadow.innerHTML = '<style>:host{display:none;}</style>';
      return;
    }
    const max = Math.max(...entries.map((e) => e[1]));
    const rows = entries.map(([city, count], i) => /* html */ `
<div class="row" style="--pct:${(count / max) * 100}%">
  <div class="rank">${String(i + 1).padStart(2, '0')}</div>
  <div class="info">
    <div class="name">${escapeHtml(city)}</div>
    <div class="bar"><span></span></div>
  </div>
  <div class="count">${count}</div>
</div>`).join('');

    this.#shadow.innerHTML = /* html */ `
<style>
:host {
  display: block;
  view-transition-name: cities;
}
.title { font-family: var(--mono); font-size: 10px; letter-spacing: 0.42em; text-transform: uppercase; color: var(--ink-faint); margin-bottom: 14px; padding-left: 4px; }
.list { display: grid; gap: 2px; background: var(--paper-up); border: 1px solid var(--rule); border-radius: 8px; overflow: hidden; }
.row {
  display: grid;
  grid-template-columns: 36px 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid var(--rule);
  transition: background 220ms cubic-bezier(0.32, 0.72, 0, 1);
}
.row:hover {
  background: color-mix(in oklch, var(--peach) 10%, var(--paper-up));
}
.row:last-child { border-bottom: none; }
.rank { font-family: var(--mono); font-size: 10px; color: var(--maroon); letter-spacing: 0.12em; font-feature-settings: 'tnum' 1; }
.info { display: grid; gap: 6px; min-width: 0; }
.name { font-family: var(--display); font-size: 19px; color: var(--ink); font-weight: 600; letter-spacing: -0.005em; }
.bar { height: 3px; background: oklch(94% 0.03 25); border-radius: 999px; overflow: hidden; }
.bar span { display: block; height: 100%; width: var(--pct); background: linear-gradient(90deg, var(--maroon), var(--maroon-bright)); animation: g 720ms var(--tx-snap) both; }
.count {
  font-family: var(--display);
  font-size: 26px;
  font-weight: 700;
  color: var(--ink);
  font-feature-settings: 'tnum' 1, 'ss01' 1, 'cv11' 1, 'lnum' 1;
  letter-spacing: -0.022em;
  line-height: 1;
  font-style: italic;
}
@keyframes g { from { transform: scaleX(0); transform-origin: left; } to { transform: scaleX(1); } }
</style>
<div class="title">Har sheher mein</div>
<div class="list">${rows}</div>
`;
  }
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] ?? c));
}

customElements.define('dial-cities', DialCities);
